import React, { useState } from "react";
import { Logo } from "../assets/logo";
import { NavigationItems } from "../constants/constants";
import { FaTimes } from "react-icons/fa";
import { RiMenu3Fill } from "react-icons/ri";
import { BookButton } from "../ui/BookButton";
import { useTranslation } from "react-i18next";

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const scrollToSection = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      closeMenu();
    }
  };

  return (
    <div className="relative md:flex justify-between items-center border-b-[1.5px] border-neutral-100 md:border-none p-4 md:w-[95%] lg:w-full md:justify-center">
      <div className="flex justify-between w-full md:w-auto items-center ">
        <div className="md:hidden">
          <Logo />
        </div>
        <div className="ml-auto h-inherit md:hidden">
          <BookButton className="w-full" />
        </div>
        <button
          onClick={toggleMenu}
          className="ml-auto text-3xl text-primary-500 md:hidden"
        >
          {isOpen ? (
            <FaTimes color={"#6C3BC7"} />
          ) : (
            <div className="bg-primary-600 px-3 py-2 rounded-[8px]">
              <RiMenu3Fill color={"#6C3BC7"} />
            </div>
          )}
        </button>
      </div>

      {/* Mobile Navigation Menu */}
      {isOpen && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-10"
            onClick={closeMenu}
          />

          <div className="fixed top-0 left-0 w-[75%] h-full bg-white z-20 shadow-lg p-6 space-y-6">
            <div className="flex justify-between items-center">
              <Logo />
              <button
                onClick={closeMenu}
                className="text-3xl text-primary-500 md:hidden"
              >
                <FaTimes />
              </button>
            </div>
            <div className="flex flex-col items-start space-y-4">
              {NavigationItems.map((eachItem) => (
                <p
                  key={eachItem.value}
                  className="text-primary-500 text-lg p-2 cursor-pointer"
                  onClick={() => scrollToSection(eachItem.value)}
                >
                  {String(t(`navigation.${eachItem.value}`))}
                </p>
              ))}
            </div>

            <div className="mt-4">
              <BookButton className="w-full" />
            </div>
          </div>
        </>
      )}

      {/* Desktop Navigation */}
      <div className="hidden md:flex w-fit md:w-[800px] lg:w-[856px] md:mt-[40px] lg:mt-[46px] border-solid bg-white rounded-md border-xs border-neutral-100 px-4 py-2 items-center justify-between">
        <Logo />
        <div className="flex text-primary-500 font-500 cursor-pointer gap-4-res text-[16px] font-medium tracking-[-0.32px]">
          {NavigationItems.map((eachItem) => (
            <p
              key={eachItem.value}
              className="hover:text-primary-200 hover:scale-105 transition duration-300 ease-in-out"
              onClick={() => scrollToSection(eachItem.value)}
            >
              {String(t(`navigation.${eachItem.value}`))}
            </p>
          ))}
        </div>
        <BookButton />
      </div>
    </div>
  );
};
